import React from "react";
import { formatCompactNumber } from "@/utils/commonFunctions";
import { BucketCardConfig } from "@/type/financialPageTypes";

export function fmtINR(value: number): string {
  return `₹${formatCompactNumber(value, true, 2)}`;
}

function getBorderClasses(index: number): string {
  const isLeftCol = index % 2 === 0;
  const isTopRow = index < 2;

  if (isTopRow && isLeftCol) return "border-r border-b";
  if (isTopRow && !isLeftCol) return "border-b";
  if (!isTopRow && isLeftCol) return "border-r";
  return "border-t";
}

export default function RetirementBucketGrid({
  buckets,
  isPostSummary,
}: {
  buckets: BucketCardConfig[];
  isPostSummary?: boolean;
}) {
  return (
    <div className="grid grid-cols-2 xs:gap-2 sm:gap-2.5 flex-1 bg-white/10 xs:bg-transparent rounded-xl xs:rounded-none p-2 xs:p-0">
      {buckets.map((card, index) => (
        <div
          key={card.title}
          className={[
            "text-center xs:text-left xs:rounded-2lg sm:rounded-xl xs:border border-dashed xs:border-solid border-white/50 xs:bg-white/10",
            isPostSummary ? "py-2 xs:px-3 xs:py-2.5" : "py-2 xs:px-3 xs:py-3.5",
            getBorderClasses(index),
          ].join(" ")}
        >
          <p className="mb-1 flex items-center justify-center xs:justify-normal gap-1.5 text-2xs font-medium text-white/75">
            <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: card.dotColor }} />
            {card.title}
          </p>

          <p className="mb-1 text-sm sm:text-xl sm:leading-1.2 font-bold text-white">{fmtINR(card.value)}</p>

          <p className="flex items-center justify-center xs:justify-normal gap-1 text-xs font-semibold text-white">
            {card.prefix}

            <span
              className={["text-xs sm:text-2xs", card.secondaryValue > 0 ? "text-[#22E100]" : "text-[#e10000]"].join(
                " ",
              )}
            >
              {fmtINR(card.secondaryValue)}
            </span>

            {card.suffix}
          </p>
        </div>
      ))}
    </div>
  );
}
